import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    ProductPriceContainer as SourceProductPriceContainer
} from 'SourceComponent/ProductPrice/ProductPrice.container';
import { ProductType } from 'Type/ProductList.type';

/** @namespace Elganso/Component/ProductPrice/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // TODO extend mapStateToProps
});

/** @namespace Elganso/Component/ProductPrice/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // TODO extend mapDispatchToProps
});

/** @namespace Elganso/Component/ProductPrice/Container */
export class ProductPriceContainer extends SourceProductPriceContainer {
    static propTypes = {
        ...super.propTypes,
        product: ProductType,
        skuActivo: PropTypes.string
    };

    static defaultProps = {
        ...super.defaultProps,
        product: {}
    };

    containerProps() {
        const {
            product,
            skuActivo
        } = this.props;

        return {
            product,
            skuActivo,
            ...super.containerProps()
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPriceContainer);
